import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, LineChart, Bar, Line, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList } from 'recharts';
import { Row, Col, Table } from 'reactstrap';
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";

export default function ReceitaOperacionalChart({ receitaOperacionalData }) {

  const [chartAndTableData, setChartAndTableData] = React.useState([]);
  const { getLegendPosition, windowWidth } = ResponsiveLegend();

  useEffect(() => {
    if (receitaOperacionalData && receitaOperacionalData.length > 0) {
      let mappedData = receitaOperacionalData.map((data) => ({
        name: formateMonthName(data.mesAno),
        percentualReceitaOperacionalProduto: data.percentualReceitaOperacionalProduto,
        percentualReceitaOperacionalServico: data.percentualReceitaOperacionalServico,
        receitaOperacionalServicoPdv: data.receitaOperacionalServicoPdv,
        receitaOperacionalProdutoPdv: data.receitaOperacionalProdutoPdv,
        servico: data.servico,
        produto: data.produto
      }));
      setChartAndTableData(mappedData);
    }
  }, [receitaOperacionalData]);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const valueProdutoBar = `${new Intl.NumberFormat('pt').format(data.percentualReceitaOperacionalProduto)}%`
      const valueServicoBar = `${new Intl.NumberFormat('pt').format(data.percentualReceitaOperacionalServico)}%`
      const valueServicoLine = `R$ ${data.receitaOperacionalServicoPdv.toLocaleString('pt-BR').split(',')[0]}`;
      const valueProdutoLine = `R$ ${data.receitaOperacionalProdutoPdv.toLocaleString('pt-BR').split(',')[0]}`;
      return (
        <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
          <p>{data.name}</p>
          <p>PRODUTO %: {valueProdutoBar}</p>
          <p>SERVIÇO %: {valueServicoBar}</p>
          <p>SERVIÇO/PDV: {valueServicoLine}</p>
          <p>PRODUTO/PDV: {valueProdutoLine}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <ResponsiveContainer width='99%' height={400}>
        <ComposedChart
          width={1200}
          height={400}
          data={chartAndTableData}
          margin={{
            top: 20,
            right: 30,
            left: 5,
            bottom: 10
          }}
        >
          <XAxis dataKey="name" stroke="#000" axisLine={false} tickLine={false} style={{ fontWeight: 'bold' }} />
          <YAxis hide />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            align={windowWidth > 600 ? 'left' : 'center'}
            layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
            iconSize={10}
            wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(),  minWidth: '140px', width: '140px',maxWidth: '140px'} : { ...getLegendPosition() }}
            formatter={(value, entry) => <span style={{ color: '#000', fontSize: '10px' }}>{value}</span>}
            payload={[
              { value: 'PRODUTO %', type: "rect", color: "#c3cfeb", }, 
              { value: 'SERVIÇO %', type: "rect", color: "#d5d9e8" },
              { value: 'SERVIÇO/PDV', type: "line", color: "#0B3D86" }, 
              { value: 'PRODUTO/PDV', type: "line", color: "#54668f" },
            ]}
          />
          <Bar
            dataKey="percentualReceitaOperacionalServico"
            name="SERVIÇO %"
            fill="#d5d9e8"
            stackId="123"
          />
          <Bar
            dataKey="percentualReceitaOperacionalProduto"
            name="PRODUTO %"
            fill="#c3cfeb"
            stackId="123"
          />
          <Line type="monotone" dataKey="percentualReceitaOperacionalProduto" name="SERVIÇO/PDV" stroke="#0B3D86" dot={false}>
            <LabelList
              dataKey="receitaOperacionalServicoPdv"
              fill="#0B3D86"
              formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
              position="insideBottom"
              fontSize="11px"
            />
          </Line>
          <Line type="monotone" dataKey="percentualReceitaOperacionalServico" name="PRODUTO/PDV" stroke="#54668f" dot={false}>
            <LabelList
              dataKey="receitaOperacionalProdutoPdv"
              fill="#54668f"
              formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
              position="insideBottom"
              fontSize="11px"
            />
          </Line>
        </ComposedChart>
      </ResponsiveContainer>
      <div style={{ marginRight: '40px' }}>
        <table
          style={{
            width: '100%',
            borderTop: '1px solid #000',
            borderBottom: '1px solid #000',
            overflow: 'auto',
            tableLayout: 'fixed'
          }}>
          <tbody>
            <tr>
              <th style={{ minWidth: '135px', width: '135px'}}>SERVIÇO</th>
              {chartAndTableData.map((item, index) => (
                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                  {item.servico.toLocaleString('pt-BR').split(',')[0]}
                </td>
              ))}
            </tr>
            <tr style={{ border: '1px dotted #000' }}></tr>
            <tr style={{ borderBottom: '1px solid #000', }}>
              <td><i>(TOTAL%)</i></td>
              {chartAndTableData.map((item, index) => (
                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                  {`${(item.percentualReceitaOperacionalServico)}%`}
                </td>
              ))}
            </tr>
            <tr>
              <th style={{ minWidth: '135px', width: '135px'}}>PRODUTO</th>
              {chartAndTableData.map((item, index) => (
                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                  {item.produto.toLocaleString('pt-BR').split(',')[0]}
                </td>
              ))}
            </tr>
            <tr style={{ border: '1px dotted #000' }}></tr>
            <tr>
              <td><i>(TOTAL%)</i></td>
              {chartAndTableData.map((item, index) => (
                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                  {`${(item.percentualReceitaOperacionalProduto)}%`}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
